'use strict';

angular.module('cloudBillingLegacyFrontend').controller('CspUpdateV1AccountCtrlMixin', function($scope, $modal) {

  $scope.openCspUpdateV1AccountDialog = function(exitingAccountModel) {

    var modalInstance = $modal.open({
      templateUrl: "views/csp/modals/modal_ac_csp_update_v1_account.html",
      controller: 'ModalCspUpdateV1AccountCtrl',
      resolve: {
        AccountModel: function() {
          return exitingAccountModel ? exitingAccountModel : {};
        }
      }
    });

    // returns a promise
    return modalInstance.result;
  };
});
